"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.filterNestedSelectFilter = filterNestedSelectFilter;
exports.getNestedSelectFilterParams = getNestedSelectFilterParams;
exports.getNestedSelectFilterQuery = getNestedSelectFilterQuery;
exports.initializeNestedSelectState = initializeNestedSelectState;
exports.isNestedSelectStatePristine = isNestedSelectStatePristine;
exports.isNestedSelectStateUncommitted = isNestedSelectStateUncommitted;
exports.toggleNestedSelectState = toggleNestedSelectState;
exports.updateNestedSelectState = updateNestedSelectState;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _join2 = _interopRequireDefault(require("lodash/join"));
var _every2 = _interopRequireDefault(require("lodash/every"));
var _split3 = _interopRequireDefault(require("lodash/split"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _some2 = _interopRequireDefault(require("lodash/some"));
var _selectFilter = require("./select-filter.utils");
var _filters = require("../../constants/filters.constants");
function getNestedSelectFilterParams(state) {
  return (0, _map2.default)(state, function (legState) {
    return {
      origin: (0, _selectFilter.getSelectFilterParams)(legState.origin),
      destination: (0, _selectFilter.getSelectFilterParams)(legState.destination)
    };
  });
}
function getNestedSelectFilterQuery(params) {
  if ((0, _isEmpty2.default)(params)) {
    return undefined;
  }
  var queryArray = (0, _map2.default)(params, function (legParams) {
    var originQuery = (0, _selectFilter.getSelectFilterQuery)(legParams === null || legParams === void 0 ? void 0 : legParams.origin, _filters.FILTER_SPECIAL_MAP.SELECT_ALL);
    var destinationQuery = (0, _selectFilter.getSelectFilterQuery)(legParams === null || legParams === void 0 ? void 0 : legParams.destination, _filters.FILTER_SPECIAL_MAP.SELECT_ALL);
    return (0, _join2.default)([originQuery, destinationQuery], _filters.FILTER_SEPARATOR_MAP.DIRECTION);
  });
  if ((0, _every2.default)(queryArray, function (query) {
    return query === _filters.FILTER_SPECIAL_MAP.DIRECTION_SELECT_ALL;
  })) {
    return undefined;
  }
  return (0, _join2.default)(queryArray, _filters.FILTER_SEPARATOR_MAP.LEG);
}
function updateNestedSelectState(state, query) {
  var params = (0, _split3.default)(query, _filters.FILTER_SEPARATOR_MAP.LEG);
  return (0, _map2.default)(state, function (legState, legIndex) {
    var _split2 = (0, _split3.default)(params[legIndex], _filters.FILTER_SEPARATOR_MAP.DIRECTION),
      originParams = _split2[0],
      destinationParams = _split2[1];
    return {
      origin: (0, _selectFilter.toggleMultiSelectState)(legState === null || legState === void 0 ? void 0 : legState.origin, (0, _selectFilter.getSelectFilterParamsFromQuery)(originParams)),
      destination: (0, _selectFilter.toggleMultiSelectState)(legState === null || legState === void 0 ? void 0 : legState.destination, (0, _selectFilter.getSelectFilterParamsFromQuery)(destinationParams))
    };
  });
}
function toggleNestedSelectState(state, payload) {
  return (0, _map2.default)(state, function (legState, index) {
    if (payload.index !== index || !(0, _includes2.default)(_filters.FLIGHT_LEG_TYPE_MAP, payload.type)) {
      return legState;
    }
    var toggledLegState = legState;
    toggledLegState[payload === null || payload === void 0 ? void 0 : payload.type] = (0, _selectFilter.toggleMultiSelectState)(legState[payload === null || payload === void 0 ? void 0 : payload.type], [payload === null || payload === void 0 ? void 0 : payload.code]);
    return toggledLegState;
  });
}
function isNestedSelectStatePristine(state) {
  return (0, _every2.default)(state, function (legState) {
    var isOriginPristine = (0, _selectFilter.isSelectFilterStatePristine)(legState === null || legState === void 0 ? void 0 : legState.origin);
    var isDestinationPristine = (0, _selectFilter.isSelectFilterStatePristine)(legState === null || legState === void 0 ? void 0 : legState.destination);
    return isOriginPristine && isDestinationPristine;
  });
}
function isNestedSelectStateUncommitted(uncommittedState, state) {
  return (0, _some2.default)(state, function (legState, index) {
    var legUncommittedState = uncommittedState[index];
    return (0, _selectFilter.isSelectFilterStateUncommitted)(legUncommittedState === null || legUncommittedState === void 0 ? void 0 : legUncommittedState.origin, legState === null || legState === void 0 ? void 0 : legState.origin) || (0, _selectFilter.isSelectFilterStateUncommitted)(legUncommittedState === null || legUncommittedState === void 0 ? void 0 : legUncommittedState.destination, legState === null || legState === void 0 ? void 0 : legState.destination);
  });
}
function initializeNestedSelectState(filterData, labelFactory) {
  if (filterData === void 0) {
    filterData = [];
  }
  return (0, _map2.default)(filterData, function (legFilterData) {
    var origin = (0, _selectFilter.initializeMultiSelectState)(legFilterData === null || legFilterData === void 0 ? void 0 : legFilterData.origin, labelFactory);
    var destination = (0, _selectFilter.initializeMultiSelectState)(legFilterData === null || legFilterData === void 0 ? void 0 : legFilterData.destination, labelFactory);
    return {
      origin: origin,
      destination: destination
    };
  });
}
function filterNestedSelectFilter(filterParams, itineraryFilterData) {
  return (0, _every2.default)(itineraryFilterData, function (_ref, legIndex) {
    var _filterParams$legInde, _filterParams$legInde2;
    var origin = _ref.origin,
      destination = _ref.destination;
    return (0, _selectFilter.filterSelectFilter)((_filterParams$legInde = filterParams[legIndex]) === null || _filterParams$legInde === void 0 ? void 0 : _filterParams$legInde.origin, origin) && (0, _selectFilter.filterSelectFilter)((_filterParams$legInde2 = filterParams[legIndex]) === null || _filterParams$legInde2 === void 0 ? void 0 : _filterParams$legInde2.destination, destination);
  });
}